import { BookingInformation } from '@repo/ui/molecules';
import type { CalendarStepT, Ical } from '../steps/types';
import { useStudyContext } from '../utils/StudyContext';
import { useTranslationsContext } from '../utils/TranslationsContext';
import { getQueryParam } from '../utils/utils';
import AddToCalendar from './AddToCalendar';

type Props = {
    selectedSlot?: string | null;
    ical?: Ical;
};

const BookingSummary = ({ selectedSlot, ical }: Props) => {
    const { study } = useStudyContext();
    const slot = (
        study?.steps.find((v) => v.type === 'calendarStep') as CalendarStepT
    ).slots.find((v) => v.reference === selectedSlot);
    const { t } = useTranslationsContext();

    const paramEmail = getQueryParam('email');
    if (!slot) {
        return <div />;
    }

    return (
        <BookingInformation
            content={{
                ariaLabel: t('calendarStep.summary'),
                header: t('calendarStep.header'),
                min: t('common.minute'),
                videoCall: t('calendarStep.videoCall'),
            }}
            endDate={slot.endDate}
            timezone={{
                value: new Intl.DateTimeFormat().resolvedOptions().timeZone,
                translation: t('calendarStep.timezone'),
            }}
            startDate={slot.startDate}
            language={study.language}
            location={study.location}
            locationType={study.locationType}
            slotLength={study.slotLength}
            email={paramEmail === null ? undefined : paramEmail}
        >
            {!!ical && (
                <div>
                    <AddToCalendar {...ical} />
                </div>
            )}
        </BookingInformation>
    );
};

export default BookingSummary;
